import { mapState, mapActions, mapGetters } from 'vuex'
import CONSTANTS from '@/constants'
import { eventsConstants } from '../eventsList'

export const mixpanelEvent = {
  computed: {
    ...mapState({
      shoppingCart: state => state.shoppingCart.shoppingCart,
      paymentMethod: state => state.subscriptions.paymentMethod,
      paymentEntries: state => state.subscriptions.paymentEntries,
      userProfile: state => state.auth.userProfile,
      isAuthenticated: state => state.auth.isAuthenticated,
    }),
    ...mapGetters({
      couponStrState: 'coupons/getCoupon',
      couponObj: 'coupons/getCouponObj',
      taxesStr: 'priceDetails/getTaxesStr',
      totalStr: 'priceDetails/getTotalStr',
    }),
    eventsConstants() {
      return eventsConstants
    },
  },
  methods: {
    ...mapActions({
      sendGAEvent: 'events/sendGAEvent',
    }),
    sendMixpanelEvent(event, payload) {
      this.$store.dispatch('events/sendMixpanelEvent', {
        event_name: event,
        properties: {
          ...payload,
        },
      })
    },
    gaItemsCollection() {
      let items = this.shoppingCart
        .map(item => {
          const {
            id: itemId,
            name,
            price,
            merchant_id,
            discounted_price_cents,
            user_receives_discount,
          } = item
          if (merchant_id === CONSTANTS.PLANS.SKILL_DIVE_ANNUAL) return
          const priceParsed = user_receives_discount
            ? discounted_price_cents.toString().replace('$', '')
            : price.toString().replace('$', '')
          return {
            item_id: itemId,
            item_name: name,
            coupon: this.customCoupon,
            discount: this.gaGetItemDiscountValue(item),
            price: priceParsed,
            quantity: 1,
            item_category: item.product_type,
          }
        })
        .filter(i => !!i)
      const cartWithSkillDive = this.shoppingCart.find(
        product => product.merchant_id === CONSTANTS.PLANS.SKILL_DIVE_ANNUAL
      )
      if (cartWithSkillDive) {
        items = [...items, ...this.gaSkillDiveItemsCollection()]
      }
      return items
    },
    gaSkillDiveItemsCollection(context) {
      const items = []
      const that = context ? context.rootState.shoppingCart : this
      const cartWithSkillDive = that.shoppingCart.find(
        product => product.merchant_id === CONSTANTS.PLANS.SKILL_DIVE_ANNUAL
      )
      let discount = this.gaGetItemDiscountValue(cartWithSkillDive, context)
      discount = (discount / (cartWithSkillDive.addOnsOnCart.length + 1)).toFixed(2)
      let coupon = ''
      if (context) {
        coupon = that.coupon
      } else {
        coupon = this.customCoupon
      }
      if (cartWithSkillDive) {
        items.push({
          item_id: cartWithSkillDive.id,
          item_name: cartWithSkillDive.name,
          coupon,
          discount,
          price: (cartWithSkillDive.priceToShow / 100).toFixed(2),
          quantity: 1,
          item_category: cartWithSkillDive.product_type,
        })
        cartWithSkillDive.addOnsOnCart.forEach(SDaddOn => {
          const { id, name, product_type, price_cents } = SDaddOn
          items.push({
            item_id: id,
            item_name: name,
            coupon,
            discount,
            price: (price_cents / 100).toFixed(2),
            quantity: 1,
            item_category: product_type,
          })
        })
      }
      return items
    },
    gaObjectCreation(product, context, gaEvent) {
      if (!context) context = null
      const { SKILL_DIVE_ANNUAL } = CONSTANTS.PLANS
      const { id, name, merchant_id, product_type } = product
      const price = this.gaGetItemPrice(product)
      const itemPriceParsed = (price / 100).toFixed(2)
      let total = 0
      if (context) {
        context.rootState.shoppingCart.shoppingCart.forEach(item => {
          if (item.user_receives_discount) {
            total += item.discounted_price_cents
          } else {
            total += item.price_cents
          }
        })
        total = (total / 100).toFixed(2)
      }
      const category = product_type
      const couponStr = context ? context.getters['coupons/getCoupon'] : this.couponStrState
      const discount = this.gaGetItemDiscountValue(product, context)
      const finalItemPrice = (Number(itemPriceParsed) - Number(discount)).toFixed(2)
      const items =
        merchant_id === SKILL_DIVE_ANNUAL
          ? this.gaSkillDiveItemsCollection(context)
          : [
              {
                coupon: couponStr,
                discount,
                item_category: category,
                item_id: id,
                item_name: name,
                price: itemPriceParsed,
                quantity: 1,
              },
            ]
      return {
        event: gaEvent,
        ecommerce: {
          currency: 'USD',
          value: finalItemPrice,
          items,
        },
      }
    },
    gaAddToCartEvent(product, context) {
      const GAObj = this.gaObjectCreation(product, context, eventsConstants.CHECKOUT_GA_ADD_TO_CART)
      if (context) {
        context.dispatch('events/sendGAEvent', GAObj, {
          root: true,
        })
      } else {
        this.sendGAEvent(GAObj)
      }
    },
    gaRemoveFromCartEvent(product, context) {
      const GAObj = this.gaObjectCreation(
        product,
        context,
        eventsConstants.CHECKOUT_GA_REMOVE_FROM_CART
      )
      if (context) {
        context.dispatch('events/sendGAEvent', GAObj, {
          root: true,
        })
      } else {
        this.sendGAEvent(GAObj)
      }
    },
    gaGetItemDiscountValue(product, context) {
      const { merchant_id } = product
      const price = this.gaGetItemPrice(product)
      const couponStr = context ? context.getters['coupons/getCoupon'] : this.couponStrState
      let discount = '0.00'
      if (couponStr !== '') {
        const couponObj = this.couponObj
        let itemHasDiscount = false
        if (couponObj?.plans || couponObj?.items) {
          const itemsWithDiscount = [
            ...couponObj.plans.map(ciPlan => ciPlan.code),
            ...couponObj.items.map(ciItem => ciItem.code),
          ]
          itemHasDiscount = itemsWithDiscount.includes(merchant_id)
        }
        if (itemHasDiscount) {
          let totalDiscountToApply = 0
          if (couponObj.discount && couponObj.discount.percent) {
            const { percent } = couponObj.discount
            totalDiscountToApply += (percent * (price / 100)) / 100
          } else if (couponObj.discount && couponObj.discount.amount) {
            const { amount } = couponObj.discount
            totalDiscountToApply = amount
          }
          discount = totalDiscountToApply.toFixed(2)
        }
      }
      return discount
    },
    gaGetItemPrice(product) {
      let price = ''
      if (product.user_receives_discount) {
        price = product.discounted_price_cents
      } else {
        price = product.price_cents
      }
      if (typeof price === 'string') {
        price = Number(price.replace('$', '')) * 100
      }
      return price
    },
    gaAddPaymentInfo() {
      const items = this.gaItemsCollection()
      const totalPriceParsed = (
        Number(this.totalStr) -
        Number(this.taxesStr || 0) -
        Number(this.currentDiscount)
      ).toFixed(2)
      const GAObj = {
        event: eventsConstants.CHECKOUT_GA_ADD_PAYMENT_INFO,
        ecommerce: {
          currency: 'USD',
          value: totalPriceParsed,
          coupon: this.customCoupon,
          payment_type: this.paymentMethod,
          items,
        },
      }
      this.$store.dispatch('events/sendGAEvent', GAObj)
    },
    gaPurchase({ transaction_id }) {
      const items = this.gaItemsCollection()
      const totalPriceParsed = (Number(this.totalStr) - Number(this.taxesStr || 0)).toFixed(2)
      const { id, user_id, preferred_phone_number, email, first_name, last_name } = this.userProfile
      const { phone, streetAddress, state, city, country, zip } = this.paymentEntries
      const GAObj = {
        event: eventsConstants.CHECKOUT_GA_PURCHASE,
        ecommerce: {
          transaction_id,
          value: totalPriceParsed,
          tax: this.taxesStr,
          currency: 'USD',
          coupon: this.customCoupon,
          items,
          user: {
            user_id: id || user_id,
            email,
            first_name,
            last_name,
            phone: this.isAuthenticated ? preferred_phone_number : phone,
            street: streetAddress,
            city,
            region: state,
            country,
            postcode: zip,
          },
        },
      }
      this.$store.dispatch('events/sendGAEvent', GAObj)
    },
    gaBeginCheckout() {
      // totalStr declared in the component
      const items = this.gaItemsCollection()
      const GAObj = {
        event: eventsConstants.CHECKOUT_GA_BEGIN_CHECKOUT,
        ecommerce: {
          currency: 'USD',
          value: this.totalStr,
          coupon: this.customCoupon,
          items,
        },
      }
      this.$store.dispatch('events/sendGAEvent', GAObj)
    },
  },
}
